<template>
<div class="container-fluid">
	<apps-toolbar title="Marketplace" icon="fa-th-large"></apps-toolbar>

	<div class="d-flex justify-content-between align-items-center mb-3">
		<h3 class="mb-0">Addon App Marketplace</h3>

		<div>
			<search-bar placeholder="Search for an app..." v-on:submit="fetchAvailableApps"></search-bar>
		</div>
	</div>

	<p v-if="availableApps.length == 0">The app store is empty :(</p>

	<p>Apps here have been written by 3rd party developers and have been published on the {{$store.appName}} platform for open use.</p>

	<div class="row no-gutters row-eq-height">
		<div v-for="(app,index) in availableApps" class="col-xl-6">
			<addon-app-card
				:is-installed="'AddonAppInstalled' in app && app.AddonAppInstalled.length > 0" 
				:app="app"
				:editable="false"
				:hide-uninstall-button="true"
				v-on:uninstall="uninstall(index)"
				v-on:install="installApp"
				v-on:uiLocationChange="appUiLocationChange($event,app)"
				v-on:inTopMenuChange="appInTopMenuChange($event,app)"
				v-on:inSideMenuChange="appInSideMenuChange($event,app)"
				v-on:tokenIsReadonlyChange="appTokenIsReadonlyChange($event,app)">
			</addon-app-card>
		</div>
	</div>
</div>
</template>

<script>
import AppsToolbar from "./AppsToolbar"

import AddonAppCard from "@/components/AddonAppCard"
import SearchBar from "@/components/SearchBar"

import AppsMixins from "@/mixins/AppsMixins.js"

export default {

	name: 'AppStore',
	mixins: [AppsMixins],
	components: {
		AppsToolbar,
		AddonAppCard,
		SearchBar,
	},
	data() {
		return {
			availableApps: [],
			installedApps: [],
		}
	},
	watch: {
		'$store.company'() {
			this.fetchAvailableApps()
		}
	},
	methods: {
		installApp(app_id,uiLocation) {
			let vm = this

			let payload = {
				app_id: app_id,
				ui_location: uiLocation
			}

			this.postData("AddonAppInstalled/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("App installed to "+uiLocation+"!")
					vm.fetchCompanyData(false,["AddonApp"])
					vm.fetchAvailableApps()
				}
			})
		},
		uninstall(index) {
			let vm = this

			this.uninstallApp(index).then(response => {
				vm.fetchAvailableApps()
			})
		},
		fetchAvailableApps(terms) {
			let vm = this

			let params = {
				include: ["AddonAppInstalled",{model:"User",fields:["id","slug","first_name","last_name"]}]
			}

			if (terms) {
				params.filters = [
					["app_name",terms,"or","like"],
					["search_keywords",terms,"or","like"]
				]
			}

			this.spinner(true)

			this.getJSON("AddonApp/get",params,true).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.availableApps = response.data.map(app => {

						if ('AddonAppInstalled' in app && app.AddonAppInstalled.length > 0)
							app.showInstallLocation = true
						else
							app.showInstallLocation = false

						return app
					})
				}
			})
		}
	},
	created() {
		this.fetchAvailableApps()
	}
}
</script>

<style type="text/css">
	.app-details-table th,
	.app-details-table td {
		padding: 5px;
		padding-bottom: 2px;
		padding-top: 2px;
	}

	.app-details-table th {
		text-align: right;
		padding-right: 10px;
	}
</style>
